import { createReducer } from 'utils/reduxCreators';
import * as config from 'config';
import { prompts, locales } from 'localisation/root';

export const LOCALISATIONS_LOADED = 'localisation/LOCALISATIONS_LOADED';

const initialState = {
  prompts: prompts,
  locales: locales,
};

export default createReducer(initialState, {
  [LOCALISATIONS_LOADED]: (state, { payload }) => {
    return {
      ...state,
      prompts: { ...prompts, ...payload.prompts },
      locales: { ...locales, ...payload.locales },
    };
  },
});

export const loadLocalisationConfigs = () => async (dispatch, getState) => {
  const conf = config;
  //load region specific localisation config based on locale, overriding root localisation
  const localisationsFile = await import(
    `../localisation/${conf.locale}/index.js`
  );
  dispatch({ type: LOCALISATIONS_LOADED, payload: localisationsFile });
};
